module.exports = __webpack_public_path__ + "img/main_cdy.2b5d7846.jpg";